<template lang="pug">
  .stop
    header
      .flex.flex-wrap
        .logo-container.bg-red.flex.align-center.justify-center.p-r-50
            .p-l-10.p-r-10
                Logo
        .time-container.bg-white
          .p-l-10.p-r-10.space-between.flex
            .headline.flex-grow
                h1.page-headline.height-100.flex-center {{ stop.name }}
    main

      table.predictions
        thead
          tr
            th Arrivals
            th
            th Due In
        tbody(v-if="response && response.data && response.data.vehicles && response.data.vehicles.length")
          tr(v-for="(prediction, index) in response.data.vehicles.slice(0, predictionsCount)")
            td.prediction-title-container(width="60%") 
              .prediction-title(v-if="stop.direction == 'south'") \#{{ prediction.id }} Downtown 
              .prediction-title(v-else) \#{{ prediction.id }} New Center/North End 
            td 
              span.block {{ prediction.stops_away }} stop{{ prediction.stops_away !== 1 ? 's' : '' }} away
              span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            td.prediction-time-td
              .prediction-minutes 
                span(v-if="prediction.estimated_minutes_away == 1") 1 min
                span(v-else-if="prediction.estimated_minutes_away == 0") <1 min
                span(v-else) {{ prediction.estimated_minutes_away }} mins
              .prediction-time {{ prediction.estimated_arrival_time }} 
        tbody(v-else)
          tr
            td(colspan="100%")
              h2(v-if="predictionError") Cannot connect to train status
              h2(v-else) No Upcoming Vehicles


      //- div(style="background:#f3f3f3")
        .wrapper.text-center
          img(src="@/assets/prohibited-items.jpg")

      //- debug data
      div(v-if="debug" style="background:black;padding:1rem;color:white;font-family:monospace")
        h2.m-t-100 Raw response: 
        pre {{ response }}

</template>

<script>
  import Logo from '@/components/Logo'

  /**
   * Get all parts of a date
   * Example usage: 
   * const parts = getDateParts(new Date())
   **/
  function getDateParts(d){
    function isValidDate(date) {
      return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    }

    function zerofill(number, length) {
      // Setup
      var result = number.toString();
      var pad = length - result.length;

      while(pad > 0) {
        result = '0' + result;
        pad--;
      }

      return result;
    }

    if(!isValidDate(d)){
      console.error("Invalid date passed to getDateParts")
      return {}
    }

    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let day = d.getDay();
    let hour = d.getHours();
    let minute = d.getMinutes();
    if (minute < 10) {
        minute = "0" + minute;
    }
    let second = zerofill(d.getSeconds(), 2)
    let ampm = "am";
    if( hour >= 12 ) {
        hour -= 12;
        if(hour == 0){
          hour = 12
        }
        ampm = "pm";
    }
    let date = d.getDate();
    let month = d.getMonth();
    let year = d.getFullYear();

    let dayName = days[day]
    let monthName = months[month]

    return {
      day, hour, minute, second, ampm, date, month, year, dayName, monthName
    }
  }

  export default {
    components: {
      Logo
    },
    data(){
      return {
        // debug: window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('devbucket') !== -1,
        debug: false,
        predictionsCount: 1,
        predictionError: null,
        currentTime: null,
        currentDate: null,
        response: {},

        timeInterval: null,
        responseInterval: null,
      }
    },
    mounted(){
      this.setTime()
      this.timeInterval = setInterval(() => this.setTime(), 1000) //update once a second
      this.predictionsCount = this.debug ? 99 : 1
      this.predict()
      //in development, we dont want the response to ever auto refresh because it is confusing
      //otherwise do 30 seconds
      let timeout = this.debug ? 9999999 : 30000
      this.responseInterval = setInterval(() => this.predict(), timeout)

      //force the page to hard refresh in 20 minutes
      setTimeout(() => window.location.reload(true), 1200000)
    },
    beforeDestroy(){
      clearInterval(this.timeInterval)
      clearInterval(this.responseInterval)
    },
    computed: {
      stop(){
        return this.$store.state.stops.filter(stop => stop.id == this.$router.currentRoute.params.id)[0]
      },
    },
    methods: {
      predict(){
        let endpoint = ''

        if(window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('devbucket.net') !== -1 ){
          endpoint = 'https://wordpress.devbucket.net/qline-swiftly-master-api'
        } else if(window.location.href.indexOf('qlinestaging.wpengine') !== -1){
          endpoint = 'https://qlinestaging.wpengine.com/qline-swiftly-master-api'
        } else {
          endpoint = 'https://qline.evolveinsideout.com/qline-swiftly-master-api'
        }

        fetch(endpoint + '?t=' + Date.now() + '&stop=' + this.stop.id , {
          method: 'get'
        })
          .then(response => {
            if(!response.ok){
              throw response.statusText
            }
            return response
          })
          .then(response => response.json())
          .then(json => this.response = json)
          .catch(error => this.predictionError = error)
      },
      setTime(){
        const parts = getDateParts(new Date())
        this.currentTime = `${parts.hour}:${parts.minute} ${parts.ampm}`.toUpperCase()
        this.currentDate = `${parts.monthName} ${parts.date},  ${parts.year}`
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '@/sass/variables'
  
  main
    display: flex
    flex-flow: column
    min-height: 100%

  header 
    overflow: hidden
    .logo-container
      position: relative
      @media(max-width: 1024px)
        width: 100%
        padding: 15px
      &::before
        content: ''
        width: 100vw
        right: 100%
        top: 0
        height: 100%
        background: inherit
        position: absolute
        display: block
    .page-headline
      padding: 15px 0
      @media(max-width: 1024px)
          font-size: 32px
          text-align: center
    .time-container
      position: relative
      flex: 1
      padding: 10px
      &::before
        content: ''
        width: 100vw
        left: 100%
        top: 0
        height: 100%
        background: inherit
        position: absolute
        display: block
      .current-time
        font-size: 80px
        font-weight: 800
        @media(max-width: 768px)
            font-size: 32px
      .current-date
        font-size: 28px
        font-weight: 600
        @media(max-width: 768px)
            font-size: 32px
  .predictions
    width: 100%
    thead
      background: $blue
      position: relative
      border-top: 4px solid $yellow
      th
        position: relative
        z-index: 2
        text-align: left
        text-transform: uppercase
        font-weight: 600
        padding: 10px
        @media(max-width: 768px)
            font-size: 20px
        &:first-of-type
          padding-left: 1rem
    tbody
      .dark-theme & 
        color: $white
        tr:nth-of-type(odd)
          background: $black
        tr:nth-of-type(even)
          background: $gray
      .light-theme & 
        color: $white
        tr:nth-of-type(odd)
          background: $dark-blue
        tr:nth-of-type(even)
          background: $blue
          color: $black
      tr
        position: relative
        border-bottom: 4px solid $white
        &:last-of-type
          border-bottom: 0
      
      td
        position: relative
        z-index: 2
        padding: 40px 15px
        @media(max-width: 768px)
          padding: 20px 7.5px
        span
          @media(max-width: 768px)
            font-size: 18px
        
        .prediction-title,
        .prediction-minutes
          font-size: 45px
          font-weight: 600
          @media(max-width: 1024px)
            font-size: 32px
          @media(max-width: 768px)
            font-size: 18px
        .prediction-time
          @media(max-width: 768px)
            font-size: 18px
        &:first-of-type
          padding-left: 1rem
    .prediction-time-td
      min-width: 200px
      @media(max-width: 768px)
            font-size: 32px
    .prediction-title-container
      @media(max-width: 768px)
        width: auto
  .heading .wrapper
    background: $blue
    border-top: 5px solid $yellow
    text-transform: uppercase
    font-weight: 600
    padding: 10px
    padding-left: 1rem

  .light-theme .rider-alerts
    background: $white
    color: $black

  .dark-theme .rider-alerts
    background: $gray
    color: $white

  .rider-alerts-title
    margin-top: auto

  .rider-alerts 
    .wrapper
      display: flex
      justify-content: space-between
    &.multi
      .rider-alert
        &:nth-of-type(1)
          margin-right: 2rem
        &:nth-of-type(2)
          margin-left: 1rem
          padding-left: 3rem
          border-left: 4px solid $red
</style>